import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  session: null,
  emailSession: null,
  responses: {
    // JOIN CONVERSATION SECTION
    QID58: {},
    QID59: '',
    QID61: '',
    QID62: '',

    // RURAL

    QID181_4: false,
    QID181_5: false,
    QID181_6: false,
    QID181_7: false,
    QID181_8: false,
    QID181_10: false,
    QID181_11: false,
  },
  qualtricsQuestions: [],
  emailQualtricsQuestions: [],
  emailResponses: {},
}

const qualtricsSurveySlice = createSlice({
  name: 'qualtricsSurvey',
  initialState,
  reducers: {
    resetState: (state) => {
      Object.assign(state, initialState)
    },
    setSession: (state, action) => {
      state.session = action.payload
    },
    setEmailSession: (state, action) => {
      state.emailSession = action.payload
    },
    setQualtricsQuestions: (state, action) => {
      state.qualtricsQuestions = action.payload
    },
    setEmailQualtricsQuestions: (state, action) => {
      state.emailQualtricsQuestions = action.payload
    },
    addResponse: (state, action) => {
      state.responses[action.payload.questionId] = action.payload.answer
    },
    addEmailResponse: (state, action) => {
      state.emailResponses[action.payload.questionId] = action.payload.answer
    },
    addResponses: (state, action) => {
      action.payload.questionIds?.forEach((o, idx) => {
        state.responses[o] = action.payload.answers[idx]
      })
    },
    completeSurvey: (state) => {
      state.session = null
      state.responses = {}
    },
    completeEmailSurvey: (state) => {
      state.emailSession = null
      state.emailResponses = {}
    },
  },
})

export const { 
  resetState,
  setSession, 
  setEmailSession,
  setQualtricsQuestions, 
  setEmailQualtricsQuestions,
  addResponse, 
  addEmailResponse,
  addResponses,
  completeSurvey,
  completeEmailSurvey,
} = qualtricsSurveySlice.actions

export default qualtricsSurveySlice.reducer
